import {PLAN_TYPES, type PlanType} from '../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'
import {
  BrandContentError,
  GenericContentSchema,
  parseEntries,
  type GenericContent,
} from '../../../brand/lib/types/contentful'

export type PlanItem = {
  id: string
  label: string
  value: PlanType
}

const DEFAULT_PLAN_ITEMS: PlanItem[] = [
  {id: 'individual-plan-tab', value: PLAN_TYPES.Individual, label: 'For individuals'},
  {id: 'business-plan-tab', value: PLAN_TYPES.Business, label: 'For businesses'},
]

export function getPlanItems(planTypes: GenericContent | undefined): PlanItem[] {
  const planTypeEntries = planTypes?.fields.content
    ? parseEntries(planTypes.fields.content, GenericContentSchema)
    : undefined

  return (
    planTypeEntries?.map(item => {
      const {id, heading} = item.fields

      if (!id || !isPlanType(id) || !heading) {
        throw new BrandContentError(`Plan type "${id ?? item.sys.id}" must include a valid plan type id and heading`)
      }

      return {id: `${id}-plan-tab`, value: id, label: heading}
    }) ?? DEFAULT_PLAN_ITEMS
  )
}

function isPlanType(value: string): value is PlanType {
  return value === PLAN_TYPES.Individual || value === PLAN_TYPES.Business
}
